export default __webpack_public_path__ + "d258903827a9db11e6156b27ff0bc57e.svg";